import Fixed from './AspectFixed';
import Min from './AspectMin';

export default { Fixed, Min };
